
import React from 'react'
import Input from './elements/Input'
import Select from './elements/Select'

class ListItem extends React.Component {

  render() {
    let props = {
      input: this.props.input,
      value: this.props.value,
      onChange: this.props.onChange
    }

    switch (props.input.type) {
      case 'input': return (
        <div className={`filter-item filter-item-${props.input.valueFor}`}>
          <Input {...props} />
        </div>
      )
      case 'select': return (
        <div className={`filter-item filter-item-${props.input.valueFor}`}>
          <Select {...props} />
        </div>
      )
      default: return <div>Invalid Element</div>
    }
  }
}

ListItem.defaultProps = {
  input: null,
  onChange: null
}

export default ListItem
